module.exports = __webpack_public_path__ + "static/media/rob.56983132.jpg";